import LoadRms from '@/brain/event-rms/LoadRms'
import ExtractRmsFromList from '@/brain/rms/ExtractRmsFromList'
import MergeRmsFromList from '@/brain/rms/MergeRmsFromList'

const state = {
  downloadProgress: {
    status: 'standby', // standby - inprogress
    total: 0,
    loaded: 0
  }
}

const getters = {
  DOWNLOAD_STATUS: state => state.downloadProgress.status,
  LOADED_PERCENT: state => Math.round((state.downloadProgress.loaded * 100) / state.downloadProgress.total)
}
const mutations = {
  CHANGE_DOWNLOAD_STATUS: (state, status) => { state.downloadProgress.status = status },
  SET_TOTAL_BYTES: (state, totalBytes) => { state.downloadProgress.total = totalBytes },
  PROGRESS_LOADED: (state, progressValue) => { state.downloadProgress.loaded = progressValue }
}
const actions = {
  LOAD_EVENT: LoadRms,
  EXTRACT_RMS_FROM_LIST: ExtractRmsFromList,
  MERGE_RMS_FROM_LIST: MergeRmsFromList
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/view/event-rms/state/index.js